:
<template>
  <div>
    <VLabel v-if="tooltip === '' && label" :text="required ? `${label}*` : label" />
    <ToolTip v-if="tooltip !== '' && label" :text="tooltip" :top="tooltipSide">
      <VLabel :text="required ? `${label}*` : label" />
    </ToolTip>
    <v-text-field
      v-if="!textarea"
      :type="tipo"
      :hide-details="(dynamic) ? showErrors : hideDetails"
      :error-messages="error"
      :filled="filled"
      :dense="dense"
      :outlined="outlined"
      :autocomplete="autocomplete"
      :disabled="disabled"
      :readonly="readonly"
      :clearable="clearable"
      :solo="solo"
      :loading="loading"
      :hint="hint"
      :persistent-hint="persistHint"
      :rules="rules"
      :placeholder="place"
      v-model="val"
      v-mask="mascara"
      @focus="focusInput"
      @blur="blurPlaceholder()"
      :id="id"
      :min="min"
      :name="name"
      :append-icon="appendMIcon"
      :prepend-icon="prependIcon"
      @input="$emit('input', $event)"
      @click:clear="clear"
      @click:append="
        () => {
          appendMCallback();
        }
      "
      class="input"
      :class="getDateClass"
      v-bind="binded"
      @change="$emit('change', $event)"
      @keyup="$emit('keyup', $event)"
      @keydown="$emit('keydown', $event)"
      v-on:keyup.enter="onEnter"
      v-on="on"
    ></v-text-field>

    <v-textarea v-if="textarea"
      class="input mt-4"
      :auto-grow="autoGrow"
      @focus="focusPlaceholder()"
      @blur="blurPlaceholder()"
      :placeholder="place"
      :loading="loading"
      :solo="solo"
      :rows="rows"
      :error-messages="error"
      :rules="rules"
      :id="id"
      :value="val"
      :hide-details="hideDetails"
      @input="$emit('input', $event)"
      @change="$emit('change', $event)"
      @keyup="$emit('keyup', $event)"
      :disabled="disabled"
    ></v-textarea>
  </div>
</template>

<script>
import VLabel from '@/components/Label.vue';
import ToolTip from '@/components/misc/Tooltip.vue';

/* eslint-disable */
export default {
  name: 'InputField',
  components: { VLabel, ToolTip },
  data() {
    return {
      val: null,
      binded: null,
      appendMIcon: null,
      appendMCallback: () => {},
      tipo: null,
      mascara: '',
      place: this.placeholder,
      dynamic: this.dynamicDetails,
    };
  },
  methods: {
    blurPlaceholder() {
      if (this.val === '' || !this.val) {
        this.place = this.placeholder;
      }
      if (!this.dynamic && this.hint) {
        this.dynamic = true;
      }
    },
    focusPlaceholder() {
      if (this.val !== '' || !this.val) {
        this.place = '';
      }
    },
    focusInput() {
      this.place = '';
      if (this.dynamic && this.hint) {
        this.dynamic = false;
      }
    },
  },
  watch: {
    value(newVal) {
      this.val = newVal;
    },
  },
  props: {
    hideDetails: { type: Boolean, required: false, default: false },
    dynamicDetails: { type: Boolean, required: false, default: false },
    filled: { type: Boolean, required: false, default: false },
    dense: { type: Boolean, required: false, default: false },
    outlined: { type: Boolean, required: false, default: false },
    required: { type: Boolean, required: false, default: false },
    disabled: { type: Boolean, required: false, default: false },
    readonly: { type: Boolean, required: false, default: false },
    persistHint: { type: Boolean, required: false, default: false },
    loading: { type: Boolean, required: false, default: false },
    clearable: { type: Boolean, required: false, default: false },
    autoGrow: { type: Boolean, required: false, default: false },
    rules: {},
    textarea: { type: Boolean, required: false, default: false },
    focus: { type: Boolean, required: false, default: false },
    autoGrow: { type: Boolean, required: false, default: true },
    tooltip: { type: String, required: false, default: '' },
    hint: { type: String, required: false, default: '' },
    error: { type: String, required: false, default: '' },
    name: { type: String, required: false, default: '' },
    mask: { type: String, required: false, default: '' },
    rows: { type: Number, required: false, default: 5 },
    tooltipSide: { type: String, required: false, default: 'top' },
    /**
     * Deixa o input branco
     */
    solo: { type: Boolean, required: false, default: false },
    autocomplete: {},
    type: { type: String, required: false, default: 'text' },
    id: { type: String, required: false },
    label: {},
    min: {},
    value: {},
    bind: {},
    clear: { type: Function, default: () => {}, required: false },
    on: {},
    onEnter: {},
    placeholder: {},
    appendIcon: { type: String, required: false },
    prependIcon: { type: String, required: false },
    appendCallback: {},
  },
  beforeMount() {
    this.val = this.value;
    this.mascara = this.mask;
    this.tipo = this.type;
    this.binded = this.bind;
    this.appendMIcon = this.appendIcon;
    this.appendMCallback = this.appendCallback;
    if (this.type === 'password') {
      this.appendMIcon = 'mdi-eye-off';
      this.appendMCallback = () => {
        if (this.appendMIcon === 'mdi-eye-off') {
          this.appendMIcon = 'mdi-eye';
          this.tipo = 'text';
        } else {
          this.appendMIcon = 'mdi-eye-off';
          this.tipo = 'password';
        }
      };
    }
  },
  computed: {
    getDateClass() {
      if (this.tipo !== 'date') {
        return '';
      }

      if (this.tipo === 'date' && this.val) {
        return 'com-valor-date';
      } else {
        return 'sem-valor-date';
      }
    },
    showErrors() {
      if (!this.error) {
        return true;
      }
      return false;
    },
  },
};
</script>
